import type { FaireProductEntity } from "../../entity_types/product";

export const p_y36z2dbmtv: FaireProductEntity = {
  token: "p_y36z2dbmtv",
  type: "product",
  name: "Body Wash - Fleurir",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl: "https://cdn.faire.com/fastly/8adcae806e9caa070b1d5a488e2c3754e0ff4ed1fc59652718e1e0792aeadb1e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c2e0cb37a327bc91cc80bd792ac2a5c3fd148825e4c2376c172f405c33b4985.jpeg",
    "https://cdn.faire.com/fastly/06ef10512d3be0775d8c85c5f677f4eb98bd467bfe2ab560b0cb1c99e9b01873.jpeg",
    "https://cdn.faire.com/fastly/90d2f4f99cd062b8781066b4ea5a315a7841da61ca733e032ae7206eab909879.jpeg",
    "https://cdn.faire.com/fastly/5e708731c1e41938f95b4efefa43ea4330da706b70bf96324750950c223d5733.jpeg",
    "https://cdn.faire.com/fastly/73a5fe5cadbe5ea407165814232ff1d18bd5894850e2c8e9b2331a17a40eadd9.jpeg"
  ],
  priceDollars: 13.65,
  description: "A supercharged body wash that calms, hydrates, and nourishes while gently cleansing skin. The cushiony lather is infused with ultra-calming Hypochlorous Acid, Multi-Weight Hyaluronic Acid, and nourishing Botanical Oils, while mood-shifting adaptogens and two signature scents heighten connection through the senses.\n",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:41.629Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
